import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { AccountContext } from "../../../context/AccountContext";
import { FiLogOut } from "react-icons/fi";
import axios from "axios";

function UserBox() {
  const { user, logout } = useContext(AuthContext);
  const { selectedAccount, setSelectedAccount, demoAccounts, setDemoAccounts, accountHydrated } =
    useContext(AccountContext);
  const history = useHistory();
  const [accounts, setAccounts] = useState([]);
  const isDemo = demoAccounts.includes(selectedAccount);

  const isAdmin = user?.user_type === "admin" || user?.user_type === "superadmin";

  // Keep a ref so the async axios callback always reads the latest selectedAccount.
  const selectedAccountRef = useRef(selectedAccount);
  useEffect(() => { selectedAccountRef.current = selectedAccount; });

  useEffect(() => {
    // Wait for AccountContext to actually restore the persisted selection
    // before deciding it's invalid — otherwise this fires while
    // selectedAccount is still its initial "" (storageKey not ready yet,
    // since it depends on the logged-in user loading) and resets a real
    // saved account to "All Accounts" every time.
    if (!accountHydrated) return;
    axios.get("/get_all_accounts").then((res) => {
      const list = res.data.accounts || [];
      const fullList = isAdmin ? ["All Accounts", ...list] : list;
      setAccounts(fullList);
      setDemoAccounts(res.data.demo_accounts || []);

      // Only reset if the persisted selection is genuinely not in this user's account list.
      if (!fullList.includes(selectedAccountRef.current)) {
        setSelectedAccount(fullList.length > 0 ? fullList[0] : "");
      }
    });
  }, [accountHydrated]);

  const handleLogout = async () => {
    await logout();
    history.push("/pages/login");
  };

  return (
    <div className="d-flex align-items-center" style={{ gap: "16px" }}>
      <div data-testid="account-selector-wrapper" style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
        <select
          className="form-select form-select-sm"
          style={{ minWidth: "160px", paddingRight: isDemo ? "54px" : undefined }}
          value={selectedAccount}
          onChange={(e) => setSelectedAccount(e.target.value)}
        >
          {accounts.map((acc) => (
            <option key={acc} value={acc}>{acc}</option>
          ))}
        </select>
        {isDemo && (
          <span style={{
            position: "absolute", right: 28, top: "50%", transform: "translateY(-50%)",
            fontSize: 9, fontWeight: 800, letterSpacing: "0.5px",
            background: "#6f42c1", color: "#fff",
            padding: "1px 5px", borderRadius: 3, pointerEvents: "none",
          }}>DEMO</span>
        )}
      </div>

      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
        <span data-testid="user-fullname" style={{ fontWeight: 500 }}>
          {user ? `${user.firstname} ${user.lastname}` : "Loading..."}
        </span>
        <FiLogOut
          color="red"
          size={18}
          style={{ cursor: "pointer" }}
          title="Logout"
          onClick={handleLogout}
        />
      </div>
    </div>
  );
}

export default UserBox;
